import React from 'react';
import IrTabTblRow from './IrTabTblRow';
import { eForWhom, eIncluded } from '../../services/helpers/udmConstants';
import NumberConstants from "../../assets/appStyledComponents/numberConstant.json";
import { IrAmount } from './Inputs';
import { useFormContext } from 'react-hook-form';

const { num1000000 } = NumberConstants;

function IrTabTblRowAmount({ tabName, secName, keyName, selectedIrInsuranceFor, name1, name2, rowLabel, rowSubLabel = "", tooltipText = "", tooltipAriaLabel = "", isTopLine = false, isBottomLine = true, maxAmount = num1000000, isBlurUpdateNext = false, onYouBlur = () => null, onPartnerBlur = () => null, hideYourInput, hidePartnerInput, tooltipWidth, disableYourInput, disablePartnerInput }) {

    const { setValue } = useFormContext();

    const handleYouCommonBlur = (value) => {
        if (isBlurUpdateNext && selectedIrInsuranceFor === eIncluded.meAndPartner) {
            setValue(`${tabName}.${secName}.${eForWhom.partner}.${keyName}`, value);
        }
        onYouBlur();
    }
    const handlePartnerCommonBlur = (value) => {
        onPartnerBlur();
    }

    return (
        <IrTabTblRow
            selectedIrInsuranceFor={selectedIrInsuranceFor}
            rowLabel={rowLabel}
            rowSubLabel={rowSubLabel}
            isTopLine={isTopLine}
            isBottomLine={isBottomLine}
            tooltipText={tooltipText}
            tooltiparia-label={tooltipAriaLabel}
            tooltipWidth={tooltipWidth}
            input1={<IrAmount fieldName={`${tabName}.${secName}.${eForWhom.you}.${keyName}`} fieldLabel={name1} fieldAriaLabel={rowLabel + " " + name1} maxAmount={maxAmount} handleCommonBlur={handleYouCommonBlur} hideInput={hideYourInput} disabled={disableYourInput} />}
            input2={<IrAmount fieldName={`${tabName}.${secName}.${eForWhom.partner}.${keyName}`} fieldLabel={name2} fieldAriaLabel={rowLabel + " " +name2} maxAmount={maxAmount} handleCommonBlur={handlePartnerCommonBlur} hideInput={hidePartnerInput} disabled={disablePartnerInput} />}
        />
    )
}

export default React.memo(IrTabTblRowAmount);